<template>
  <div class="element-item" :class="theme"><!--
            --><div  class="grid-photo">
    <img v-if="photo" :src="photo"/>
    <video v-if="vid" autoplay loop muted playsinline>
    <source :src="vid" type="video/webm"/>
    <source :src="vidAlt" type="video/mp4"/>
  </video>
  </div><!--
        -->
    <router-link :to="path"><div class="overlay"><img v-if="logo" :src="logo"/>
    <p class="gametitle" v-if="name">{{name}}</p>
    <p class="subtext"  v-if="description">{{description}}</p>
  </div></router-link>
  </div>
</template>

<script>

export default {
  name: "game",
  props: {
    name: String,
    description: String,
    photo: Image,
    logo:String,
    vid: String,
    vidAlt: HTMLVideoElement,
    theme: String,
    path:String,
    labelHeight:String,
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style scoped>

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  display:flex;
  flex-direction:column;
  justify-content: center;
}

.more .overlay{
  background-color:var(--second);
}

.more .overlay .gametitle{  color:var(--secondlight);
}

.wph .overlay{
  background-color:var(--wph);
}

.wph
{  background-color:var(--wph);
}




.ss .overlay{
  background-color:var(--ss);
}

.hiu .overlay{
  background-color:var(--hiu);
}

.hiu .grid-photo img{
  height:100%;
  width:auto;
}

.ht .grid-photo img{
  height:200px;
  width:auto;
}

.sp .overlay{
  background-color:var(--sp);
}

.kt .overlay{
  background-color:var(--kt);
}

.dcc .overlay{
  background-color:var(--dcc);
}


.site .overlay{
  background-color:var(--seconddark);
}

.site .grid-photo img{
  -webkit-filter: brightness(90%);

}

.dcc
{  background-color:var(--dcc);
}

.fo .overlay{
  background-color:var(--fo);
}

.screen .overlay{
  background-color:var(--screen);
}

.so .overlay{
  background-color:var(--so);
}

.nca .overlay{
  background-color:var(--nca);
}
.grid-photo{
  overflow:hidden;
}


.sts .overlay img{
  width:100%;
}

.rotc .overlay img{
  width:100%;
}

.gf .overlay{
  background-color:black;
}

.fot .overlay img{
  width:100%;
}



.screen .grid-photo img{
  height:200px;
  width:auto;
}

.grid-photo video{
  height:200px;
  margin-left:-60px;
}

.grid-photo img{width:100%;}

.overlay{
  text-align:center;
}

.overlay img{
  width:80%;
  margin:0 auto;
}

.element-item{
  overflow:hidden;
}

.element-item:hover .overlay {
  opacity: 1;
  cursor:pointer;
}

.gametitle{
  text-align:center;
  width:80%;
  margin:0 auto;
  font-family: lemonmilk;
  font-size:1.5em;
  color:var(--second);
}

.subtext {
  text-align:center;
  color: white;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

</style>